export default __webpack_public_path__ + "static/media/8A.e1047eaf.jpg";